import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/FileUpload/file-upload';
import { css } from '@patternfly/react-styles';
import { InputGroup } from '../InputGroup';
import { TextInput } from '../TextInput';
import { Button, ButtonVariant } from '../Button';
import { TextArea, TextAreResizeOrientation } from '../TextArea';
import { Spinner, spinnerSize } from '../Spinner';
import { fileReaderType } from '../../helpers/fileUtils';
export var FileUploadField = function FileUploadField(_a) {
  var id = _a.id,
      type = _a.type,
      _a$value = _a.value,
      value = _a$value === void 0 ? '' : _a$value,
      _a$filename = _a.filename,
      filename = _a$filename === void 0 ? '' : _a$filename,
      _a$onChange = _a.onChange,
      onChange = _a$onChange === void 0 ? function () {} : _a$onChange,
      _a$onBrowseButtonClic = _a.onBrowseButtonClick,
      onBrowseButtonClick = _a$onBrowseButtonClic === void 0 ? function () {} : _a$onBrowseButtonClic,
      _a$onClearButtonClick = _a.onClearButtonClick,
      onClearButtonClick = _a$onClearButtonClick === void 0 ? function () {} : _a$onClearButtonClick,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isDisabled = _a.isDisabled,
      isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
      _a$isReadOnly = _a.isReadOnly,
      isReadOnly = _a$isReadOnly === void 0 ? false : _a$isReadOnly,
      _a$isLoading = _a.isLoading,
      isLoading = _a$isLoading === void 0 ? false : _a$isLoading,
      spinnerAriaValueText = _a.spinnerAriaValueText,
      _a$isRequired = _a.isRequired,
      isRequired = _a$isRequired === void 0 ? false : _a$isRequired,
      _a$isDragActive = _a.isDragActive,
      isDragActive = _a$isDragActive === void 0 ? false : _a$isDragActive,
      _a$validated = _a.validated,
      validated = _a$validated === void 0 ? 'default' : _a$validated,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? 'File upload' : _a$ariaLabel,
      _a$filenamePlaceholde = _a.filenamePlaceholder,
      filenamePlaceholder = _a$filenamePlaceholde === void 0 ? 'Drag a file here or browse to upload' : _a$filenamePlaceholde,
      _a$filenameAriaLabel = _a.filenameAriaLabel,
      filenameAriaLabel = _a$filenameAriaLabel === void 0 ? filename ? 'Read only filename' : filenamePlaceholder : _a$filenameAriaLabel,
      _a$browseButtonText = _a.browseButtonText,
      browseButtonText = _a$browseButtonText === void 0 ? 'Browse...' : _a$browseButtonText,
      _a$clearButtonText = _a.clearButtonText,
      clearButtonText = _a$clearButtonText === void 0 ? 'Clear' : _a$clearButtonText,
      _a$isClearButtonDisab = _a.isClearButtonDisabled,
      isClearButtonDisabled = _a$isClearButtonDisab === void 0 ? !filename && !value : _a$isClearButtonDisab,
      _a$containerRef = _a.containerRef,
      containerRef = _a$containerRef === void 0 ? null : _a$containerRef,
      _a$allowEditingUpload = _a.allowEditingUploadedText,
      allowEditingUploadedText = _a$allowEditingUpload === void 0 ? false : _a$allowEditingUpload,
      _a$hideDefaultPreview = _a.hideDefaultPreview,
      hideDefaultPreview = _a$hideDefaultPreview === void 0 ? false : _a$hideDefaultPreview,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      props = __rest(_a, ["id", "type", "value", "filename", "onChange", "onBrowseButtonClick", "onClearButtonClick", "className", "isDisabled", "isReadOnly", "isLoading", "spinnerAriaValueText", "isRequired", "isDragActive", "validated", 'aria-label', "filenamePlaceholder", "filenameAriaLabel", "browseButtonText", "clearButtonText", "isClearButtonDisabled", "containerRef", "allowEditingUploadedText", "hideDefaultPreview", "children"]);

  var onTextAreaChange = function onTextAreaChange(newValue, event) {
    onChange(newValue, filename, event);
  };

  return React.createElement("div", Object.assign({
    className: css(styles.fileUpload, isDragActive && styles.modifiers.dragHover, isLoading && styles.modifiers.loading, className),
    ref: containerRef
  }, props), React.createElement("div", {
    className: styles.fileUploadFileSelect
  }, React.createElement(InputGroup, null, React.createElement(TextInput, {
    isReadOnly // Always read-only regardless of isReadOnly prop (which is just for the TextArea)
    : true,
    isDisabled: isDisabled,
    id: "".concat(id, "-filename"),
    name: "".concat(id, "-filename"),
    "aria-label": filenameAriaLabel,
    placeholder: filenamePlaceholder,
    "aria-describedby": "".concat(id, "-browse-button"),
    value: filename
  }), React.createElement(Button, {
    id: "".concat(id, "-browse-button"),
    variant: ButtonVariant.control,
    onClick: onBrowseButtonClick,
    isDisabled: isDisabled
  }, browseButtonText), React.createElement(Button, {
    variant: ButtonVariant.control,
    isDisabled: isDisabled || isClearButtonDisabled,
    onClick: onClearButtonClick
  }, clearButtonText))), React.createElement("div", {
    className: styles.fileUploadFileDetails
  }, !hideDefaultPreview && type === fileReaderType.text && React.createElement(TextArea, {
    readOnly: isReadOnly || !!filename && !allowEditingUploadedText,
    disabled: isDisabled,
    isRequired: isRequired,
    resizeOrientation: TextAreResizeOrientation.vertical,
    validated: validated,
    id: id,
    name: id,
    "aria-label": ariaLabel,
    value: value,
    onChange: onTextAreaChange
  }), isLoading && React.createElement("div", {
    className: styles.fileUploadFileDetailsSpinner
  }, React.createElement(Spinner, {
    size: spinnerSize.lg,
    "aria-valuetext": spinnerAriaValueText
  }))), children);
};